/**
 * 售后
 */

import { setStorage, getStorage } from '@/utils/storage'

const state = () => ({
  // 明细 id 集合
  sourceItemIds: [],
})

const getters = {
  /**
   * 闭包实现 getters 传参
   * @param {*} state
   * @param {*} _
   * @param {*} rootState
   * @returns
   */
  sourceItemIds: (state, _, rootState, rootGetters) => {
    return (key) => {
      if (state.sourceItemIds.length) return state.sourceItemIds

      return (
        getStorage(
          `${rootState.user.belongCode}_${rootGetters['user/shopCode']}_${rootState.user.employeeNo}_${key}`
        ) ?? []
      )
    }
  },
}

const mutations = {
  setSourceItemIds(state, ids) {
    state.sourceItemIds = ids
  },
}

const actions = {
  setSourceItemIds({ commit, rootState, rootGetters }, { ids, key }) {
    commit('setSourceItemIds', ids)
    setStorage(`${rootState.user.belongCode}_${rootGetters['user/shopCode']}_${rootState.user.employeeNo}_${key}`, ids)
  },
}

export default { state, getters, mutations, actions }
